import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
import LazyLoad from "react-lazyload"; 
import { getFaculty } from "../Service/Api";
const StaffList = () => {  
  useEffect(() => {
    document.title = 'Staff List - St. Francis Xavier School';  
}, []); 

 const [data,setData] = useState();
     useEffect(() => {
         const fetchData = async () => {
             const faculty = await getFaculty(); 
             faculty.sort((a, b) => a.order - b.order); 
             setData(faculty);
         }
         fetchData();
     },[])
    
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>Staff List</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    {data && data.map((item, index) => ( 
                         <div className="col-sm-6 col-lg-3" key={index}>
                            <div className="faculty stafflist"> 
                                <div className="facultyimage">
                                    <LazyLoad><img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`} className="img-fluid" alt="sfxhisar"/></LazyLoad>
                                </div>
                                <div className="faculty-content">
                                    <h3> {item.name}</h3>
                                    <h4>{item.designation}</h4>
                                    <p>{item.qualification}</p>
                                    
                                </div>
                            </div>
                        </div>
                        )) }  
                    </div>  
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default StaffList;
